import { ComponentProps, FC } from 'react'
import { ThemeProvider as ThemeProviderMui } from '@mui/material/styles'
import { theme } from 'styles'

function ThemeProvider({ children }: ComponentProps<FC>): JSX.Element {
  return <ThemeProviderMui theme={theme}>{children}</ThemeProviderMui>
}

export default ThemeProvider
